// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/25e3ac58/" + chunkId + "." + __webpack_require__.h() + ".v25e3ac58.js";
};